/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Source_VimeoInputs */

const en_media_import_source_vimeo = /** @type {(inputs: Media_Import_Source_VimeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vimeo`)
};

const fr_media_import_source_vimeo = /** @type {(inputs: Media_Import_Source_VimeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vimeo`)
};

const de_media_import_source_vimeo = /** @type {(inputs: Media_Import_Source_VimeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vimeo`)
};

const it_media_import_source_vimeo = /** @type {(inputs: Media_Import_Source_VimeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vimeo`)
};

const ru_media_import_source_vimeo = /** @type {(inputs: Media_Import_Source_VimeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vimeo`)
};

const es_media_import_source_vimeo = /** @type {(inputs: Media_Import_Source_VimeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vimeo`)
};

const zh_cn2_media_import_source_vimeo = /** @type {(inputs: Media_Import_Source_VimeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vimeo`)
};

const ja_media_import_source_vimeo = /** @type {(inputs: Media_Import_Source_VimeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヴィメオ`)
};

const hi_media_import_source_vimeo = /** @type {(inputs: Media_Import_Source_VimeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विमियो`)
};

const pt_pt2_media_import_source_vimeo = /** @type {(inputs: Media_Import_Source_VimeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vimeo`)
};

/**
* | output |
* | --- |
* | "Vimeo" |
*
* @param {Media_Import_Source_VimeoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_source_vimeo = /** @type {((inputs?: Media_Import_Source_VimeoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Source_VimeoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_import_source_vimeo(inputs)
	if (locale === "de") return de_media_import_source_vimeo(inputs)
	if (locale === "it") return it_media_import_source_vimeo(inputs)
	if (locale === "ru") return ru_media_import_source_vimeo(inputs)
	if (locale === "es") return es_media_import_source_vimeo(inputs)
	if (locale === "zh-CN") return zh_cn2_media_import_source_vimeo(inputs)
	if (locale === "ja") return ja_media_import_source_vimeo(inputs)
	if (locale === "hi") return hi_media_import_source_vimeo(inputs)
	if (locale === "pt-PT") return pt_pt2_media_import_source_vimeo(inputs)
	return en_media_import_source_vimeo(inputs)
});